import React, { useEffect, useContext } from "react";
import { Route, Switch, Redirect } from "react-router-dom";
import styled from "styled-components";

import "antd/dist/antd.less";
import "./App.css";
import { UserContext } from "./context/context";
import Navigation from "./components/Navigation";
import APIPage from "./pages/API";
import Manage from "./pages/ManageApp";
import AppSetting from "./pages/AppSetting";

function App() {
  const context = useContext(UserContext);
  useEffect(() => {
    context.handler.handleUser();
  }, []);
  return (
    <AppWrapper>
      <CustomHeader>
        <Navigation />
      </CustomHeader>
      <CustomContent>
        <Switch>
          <Route path="/docs" component={APIPage} />
          <Route path="/manage" component={Manage} exact />
          <Route path="/manage/:id" component={AppSetting} />
          <Redirect to="docs#/openapi" />
        </Switch>
      </CustomContent>
    </AppWrapper>
  );
}

export default App;

const AppWrapper = styled.div`
  width: 100%;
`;

const CustomHeader = styled.header`
  background: #ffffff;
  position: relative;
  z-index: 2;
  min-height: 64px;
  height: 64px;
  width: 100%;
  padding: 0;
`;

const CustomContent = styled.div`
  background: #ffffff;
  height: calc(100vh - 64px);
  overflow: auto;
`;
